import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface LocationState {
  tier?: 'viewer' | 'creator' | 'commercial';
  email?: string;
  mfaMethod?: 'totp' | 'sms' | null;
}

export const SignupSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | null;

  const tier = state?.tier || 'viewer';
  const email = state?.email;


  const getTierDisplayName = (tierValue: string): string => {
    const tierNames: Record<string, string> = {
      viewer: 'Viewer',
      creator: 'Creator',
      commercial: 'Commercial',
    };
    return tierNames[tierValue] || tierValue;
  };

  const handleContinueToLogin = () => {
    navigate('/auth', {
      state: { email, registrationComplete: true },
    });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircleIcon
            sx={{
              fontSize: 64,
              color: 'success.main',
              mb: 2,
            }}
          />
          <Typography variant="h4" gutterBottom color="success.main">
            Account Created!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Your {getTierDisplayName(tier)} account has been created successfully.
            {email && (
              <>
                {' '}
                A confirmation has been sent to <strong>{email}</strong>.
              </>
            )}
          </Typography>
          <Typography
            variant="body2"
            sx={{ mb: 3, p: 2, bgcolor: 'info.light', borderRadius: 1 }}
          >
            You can now sign in with the password you created during signup.
          </Typography>

          <Button
            variant="contained"
            onClick={handleContinueToLogin}
            fullWidth
            size="large"
          >
            Continue to Sign In
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SignupSuccess;
